import React, { useEffect, useRef, useState } from 'react'
import { DatePicker } from 'antd'

const { RangePicker } = DatePicker

type PeriodoRangePickerProps = React.ComponentProps<typeof RangePicker>

/**
 * Base: Assessoria-Frontend-painel (components/PeriodoRangePicker).
 * RangePicker de periodo com selecao "do zero" SEM filtrar na hora:
 * - Ao ABRIR, esvazia os campos e FORCA o "Inicio" como campo ativo (mesmo clicando em "Fim"):
 *   a 1a data clicada e sempre o inicio, a 2a sempre o fim.
 * - So chama o onChange quando o usuario escolhe o RANGE COMPLETO.
 * - Se fechar sem escolher, restaura o periodo que estava.
 */
export default function PeriodoRangePicker(props: PeriodoRangePickerProps) {
  const { value, onChange, onOpenChange, onCalendarChange, ...rest } = props

  const [interno, setInterno] = useState<PeriodoRangePickerProps['value']>(value)
  const [indiceAtivo, setIndiceAtivo] = useState<0 | 1>(0)
  const abertoRef = useRef(false)
  const escolheuRef = useRef(false)

  useEffect(() => {
    if (!abertoRef.current) setInterno(value)
  }, [value])

  const handleOpenChange = (open: boolean) => {
    abertoRef.current = open
    if (open) {
      escolheuRef.current = false
      setInterno(null)
      setIndiceAtivo(0)
    } else if (!escolheuRef.current) {
      setInterno(value)
    }
    onOpenChange?.(open)
  }

  const handleCalendarChange = (dates: any, strings: any, info: any) => {
    setIndiceAtivo(info?.range === 'start' ? 1 : 0)
    onCalendarChange?.(dates, strings, info)
  }

  const handleChange = (dates: any, strings: any) => {
    escolheuRef.current = true
    setInterno(dates)
    onChange?.(dates, strings)
  }

  const extras = { activePickerIndex: indiceAtivo } as any

  return (
    <RangePicker
      {...rest}
      {...extras}
      value={interno}
      onChange={handleChange}
      onCalendarChange={handleCalendarChange}
      onOpenChange={handleOpenChange}
    />
  )
}
